<template>
    <div class="filingMaiBox">
        <div class="textOutPutBox">
            <h5>原因</h5>
            <van-field
                class="textOutPut"
                type="textarea"
                maxlength="200"
                placeholder="请填写原因"
                v-model="dontFilingMsg"
            >
            </van-field>
        </div>
        <div class="btnBox">
            <div class="submitBtn" @click="handleClickAddMsg">提交</div>
            <div class="backBtn" @click="$router.back()">返回</div>
        </div>
        <van-popup v-model="isShowPop" class="popTipsBox">
            <p class='popTips'>请先填写信息</p>
        </van-popup>
    </div>
</template>

<script>
    import api from '../../../../service/modules/complaintApis'
    import util from '../../../../utils/common'
    export default {
        data () {
            return {
                dontFilingMsg: '',
                isShowPop: false,
                type: '',
                isback:this.$store.state.complaint.isBackDetail||util.getJsonLocal('isBack'),
                item:util.getJsonLocal('item')
            }
        },
        created () {
            this.typeConversion()
        },
        methods: {
            showPop () {
                this.isShowPop = true;
            },
            typeConversion () {
                if (this.$store.state.complaint.listType.type === 'notHandle') {
                    this.type = 'waitDealCase'
                } else if (this.$store.state.complaint.listType.type === 'notAccept') {
                    this.type = 'waitAcceptCase'
                }
            },
            handleClickAddMsg () {
                if (this.dontFilingMsg === '') {
                    this.showPop()
                } else {
                    let params = {
                        mainComplainNumber: this.item.mainComplainNumber,
                        complainNumber: this.item.complainNumber,
                        subId: this.item.subId,
                        content: this.dontFilingMsg
                    }
                    api.worker.refuseCase(params).then(res => {
                        console.log(res);
                        if (res.ret === 0) {
                            this.$Toast('操作成功');
                            if(!this.isback){
                              this.$router.go(-2);
                            }else{
                                this.$router.back();
                                this.$set(this.item,'btns',[]);
                                util.setJsonLocal('item',this.item)
                            }
                        }
                    })
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .filingMaiBox{
        width: 100%;
        padding: 0 15px;
        background-color: #fff;

        .textOutPutBox{
            width: 100%;
            height: 180px;
            margin-bottom: 10px;
            padding: 20px 0;

            >h5{
                margin-bottom: 13px;
                font-size: 15px;
                font-weight: normal;
                line-height: 15px;
                color: #909090;
            }

            .textOutPut{
                height: 110px;
                padding: 15px 13px 10px;
                background-color: #F3F3F3;
                border-radius: 5px;
            }
        }

        .btnBox{
            width: 335px;
            margin: 0 auto;

            >div{
                width: 100%;
                height: 46px;
                font-size: 15px;
                text-align: center;
                line-height: 46px;
                border-radius: 5px;
            }

            .submitBtn{
                margin-bottom: 10px;
                color: #fff;
                background-color: #36B374;
            }

            .backBtn{
                color: #bdb8b8;
                background-color:#efeded;
                border: 1px solid #999;
            }
        }

        .popTipsBox{
            width: 150px;
            height: 100px;
            border-radius: 5px;

            .popTips{
                font-size: 18px;
                color: #999;
                text-align: center;
                line-height: 100px;
            }
        }
    }
</style>
